/* QUELL — product-resources: the Files/Resources cards are gated by a sign-up dialog.

   Previously a card click pressed the PDP's "add to quote" button, so asking for a render
   put the booth in the quote basket and sent the visitor to /pages/quote. Now the click
   opens snippets/resource-download-gate.liquid, the lead goes through the canonical Quell
   form intake (form_source quell_resource_download), and the file is handed straight to the
   browser. The cart is never touched.

   Consumer mailboxes are rejected: a download is only worth capturing against a work email,
   which is also the address a consultant can follow up on. Once a visitor is unlocked the
   choice is remembered for 30 days so every other card downloads on the first click.

   A signed-in dealer never sees the dialog — they qualified when their account was approved.
   Everyone else gets two ways through: sign in against the dealer API (and stay on the page),
   or leave a work email. Signing up deliberately does NOT create an account: dealer accounts
   are approved by hand within a working day, so an account-first flow could not hand over the
   file today, which is the one thing this gate exists to do. */
(function () {
  "use strict";

  var STORE_KEY = "quell_resource_unlock";
  var UNLOCK_TTL_MS = 30 * 24 * 60 * 60 * 1000;
  var SEND_TIMEOUT_MS = 6000;

  /* Consumer mailbox providers. A download gate that accepts these captures a lead nobody
     can follow up on, so they are refused with a message that names the rule. */
  var CONSUMER_DOMAINS = {
    "gmail.com": 1,
    "googlemail.com": 1,
    "hotmail.com": 1,
    "hotmail.co.uk": 1,
    "hotmail.fr": 1,
    "hotmail.it": 1,
    "hotmail.es": 1,
    "hotmail.de": 1,
    "yahoo.com": 1,
    "yahoo.co.uk": 1,
    "yahoo.fr": 1,
    "yahoo.de": 1,
    "yahoo.es": 1,
    "yahoo.it": 1,
    "ymail.com": 1,
    "rocketmail.com": 1,
    "outlook.com": 1,
    "outlook.co.uk": 1,
    "outlook.fr": 1,
    "outlook.de": 1,
    "outlook.es": 1,
    "outlook.it": 1,
    "live.com": 1,
    "live.co.uk": 1,
    "live.nl": 1,
    "live.se": 1,
    "msn.com": 1,
    "aol.com": 1,
    "icloud.com": 1,
    "me.com": 1,
    "mac.com": 1,
    "mail.com": 1,
    "gmx.com": 1,
    "gmx.de": 1,
    "gmx.net": 1,
    "web.de": 1,
    "protonmail.com": 1,
    "proton.me": 1,
    "yandex.com": 1,
    "yandex.ru": 1,
    "zoho.com": 1,
    "tutanota.com": 1,
    "fastmail.com": 1,
    "qq.com": 1,
    "163.com": 1,
    "126.com": 1,
    "naver.com": 1,
    "hanmail.net": 1,
    "orange.fr": 1,
    "wanadoo.fr": 1,
    "free.fr": 1,
    "laposte.net": 1,
    "sfr.fr": 1,
    "libero.it": 1,
    "virgilio.it": 1,
    "tiscali.it": 1,
    "terra.es": 1,
    "telefonica.net": 1,
    "btinternet.com": 1,
    "sky.com": 1,
    "virginmedia.com": 1,
    "talktalk.net": 1,
    "ntlworld.com": 1,
    "blueyonder.co.uk": 1,
    "hotmail.dk": 1,
    "telia.com": 1,
    "bredband.net": 1,
    "online.no": 1,
    "broadpark.no": 1,
  };

  var STRINGS = (window.theme && window.theme.strings) || {};
  var COPY = {
    required: STRINGS.resourceRequired || "This field is required",
    invalidEmail: STRINGS.resourceInvalidEmail || "Enter a valid email address",
    consumerEmail: STRINGS.resourceConsumerEmail || "Please use your work email — name@company.com",
    preparing: STRINGS.resourcePreparing || "Preparing your download…",
    signingIn: STRINGS.resourceSigningIn || "Signing you in…",
    loginFailed: STRINGS.errorGeneric || "Something went wrong. Please try again.",
  };

  function ready(fn) {
    if (document.readyState === "loading")
      document.addEventListener("DOMContentLoaded", fn);
    else fn();
  }

  /* ── Unlock memory. localStorage may be unavailable (private mode, blocked storage); the
     gate then simply asks again rather than failing the download. ── */
  function readUnlock() {
    try {
      var raw = window.localStorage.getItem(STORE_KEY);
      if (!raw) return null;
      var v = JSON.parse(raw);
      if (!v || !v.email || !v.ts) return null;
      if (Date.now() - v.ts > UNLOCK_TTL_MS) {
        window.localStorage.removeItem(STORE_KEY);
        return null;
      }
      return v;
    } catch (e) {
      return null;
    }
  }

  function writeUnlock(email) {
    try {
      window.localStorage.setItem(
        STORE_KEY,
        JSON.stringify({ email: email, ts: Date.now() })
      );
    } catch (e) {}
  }

  /* ── Dealer session. dealer-session.liquid puts is-dealer on <html> from the readable
     qd_dealer cookie before first paint. It is a hint, not proof — but nothing secret hangs
     off this gate, so the hint is the right level of certainty, exactly as the trade portal
     treats it. The API's own HttpOnly cookie is what authorises anything that matters. ── */
  function isSignedInDealer() {
    return document.documentElement.classList.contains("is-dealer");
  }

  /* ── Email rules ── */
  function isEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value);
  }

  function isWorkEmail(value) {
    var domain = String(value).trim().toLowerCase().split("@").pop() || "";
    return !!domain && !CONSUMER_DOMAINS[domain];
  }

  /* ── Download. Same-origin CDN files come back as a blob so the save happens without
     navigating away; anything the fetch cannot read falls back to a plain anchor click. ── */
  function fileNameFrom(url, label) {
    var path = String(url).split("?")[0].split("#")[0];
    var base = path.split("/").pop() || "";
    if (base && base.indexOf(".") > 0) return decodeURIComponent(base);
    return (label || "download").replace(/[^\w.\- ]+/g, "").trim() || "download";
  }

  function anchorDownload(url, name) {
    var a = document.createElement("a");
    a.href = url;
    a.download = name;
    a.rel = "noopener";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  function download(url, label) {
    var name = fileNameFrom(url, label);
    if (typeof window.fetch !== "function" || !window.URL || !window.URL.createObjectURL) {
      anchorDownload(url, name);
      return Promise.resolve();
    }
    return fetch(url, { credentials: "omit" })
      .then(function (res) {
        if (!res.ok) throw new Error("http_" + res.status);
        return res.blob();
      })
      .then(function (blob) {
        var objectUrl = window.URL.createObjectURL(blob);
        anchorDownload(objectUrl, name);
        setTimeout(function () {
          window.URL.revokeObjectURL(objectUrl);
        }, 60000);
      })
      .catch(function () {
        /* Cross-origin or offline: let the browser handle the URL directly. */
        anchorDownload(url, name);
      });
  }

  /* QUELL-651: the dialling-code select and the number box leave here as one
     international number plus its code (shared joiner). */
  function joinPhone(form, fields) {
    var QP = window.QuellPhone;
    return QP ? QP.joinFields(form, fields) : fields;
  }

  /* ── Lead. The canonical intake owns attribution, consent and CRM propagation; Brevo is a
     separate marketing action and only runs when the visitor ticks the opt-in. ── */
  function sendLead(form, context) {
    var jobs = [];
    var QFI = window.QuellFormIntake;

    if (QFI) {
      var ctl = QFI.register({
        formId: "resource-download",
        formSource: "quell_resource_download",
        buildFormPayload: function () {
          var payload = joinPhone(form, QFI.readForm(form));
          payload.page_path = window.location.pathname;
          // The intake caches this callback. Read the fields populated by open()
          // for this request, rather than retaining the first file's context.
          payload.resource_name = payload["contact[resource_name]"] || "";
          payload.resource_url = payload["contact[resource_url]"] || "";
          return payload;
        },
      });
      if (ctl) {
        var prepared = ctl.prepare();
        if (prepared.accepted) {
          jobs.push(
            ctl.send().then(function (res) {
              ctl.finish(res && res.ok ? "succeeded" : "failed");
              return res;
            })
          );
        }
      }
    }

    var fields = {};
    try {
      new FormData(form).forEach(function (value, key) {
        fields[key] = value;
      });
    } catch (e) {}

    if (
      fields["contact[marketing_opt_in]"] === "yes" &&
      window.BrevoIntegration &&
      window.BrevoIntegration.subscribe
    ) {
      jobs.push(
        window.BrevoIntegration.subscribe({
          email: fields["contact[email]"] || "",
          fullname: (
            (fields["contact[first_name]"] || "") +
            " " +
            (fields["contact[last_name]"] || "")
          ).trim(),
          tags: "resource-download,trade",
        })
      );
    }

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "generate_lead",
        form_id: "resource-download",
        resource_name: context.name || "",
      });
    } catch (e) {}

    if (!jobs.length) return Promise.resolve();

    /* The visitor has done their part — never hold the file hostage to a slow CRM. */
    return Promise.race([
      Promise.all(jobs),
      new Promise(function (resolve) {
        setTimeout(resolve, SEND_TIMEOUT_MS);
      }),
    ]);
  }

  /* ── Dealer sign-in. Deliberately not routed through dealer-auth.js: that handler navigates
     to the portal on success, which is the opposite of what a visitor halfway through a
     download wants. Same endpoint, same credentialed CORS call, different ending. ── */
  function dealerLogin(email, password) {
    var api = window.__dealerApi;
    if (!api) return Promise.resolve({ ok: false, error: COPY.loginFailed });
    return fetch(api + "/api/dealer/login", {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: email, password: password }),
    })
      .then(function (res) {
        return res
          .json()
          .catch(function () {
            return {};
          })
          .then(function (data) {
            /* Whatever the API chose to say is shown as-is: those strings are written for
               dealers. A network failure and a 500 read the same to someone signing in. */
            return res.ok ? { ok: true } : { ok: false, error: data.error || COPY.loginFailed };
          });
      })
      .catch(function () {
        return { ok: false, error: COPY.loginFailed };
      });
  }

  /* ── Field errors, styled like the contact form's ── */
  function showError(input, message) {
    input.classList.add("has-error");
    var field = input.closest(".ca-field") || input.parentElement;
    if (!field) return;
    var el = field.querySelector(".ca-field-help--error");
    if (!el) {
      el = document.createElement("p");
      el.className = "ca-field-help ca-field-help--error";
      field.appendChild(el);
    }
    el.textContent = message;
    input.setAttribute("aria-invalid", "true");
  }

  function clearError(input) {
    input.classList.remove("has-error");
    input.removeAttribute("aria-invalid");
    var field = input.closest(".ca-field") || input.parentElement;
    if (!field) return;
    var el = field.querySelector(".ca-field-help--error");
    if (el) el.remove();
  }

  function validate(form) {
    var inputs = [].slice.call(form.querySelectorAll("input[name]"));
    var firstBad = null;

    inputs.forEach(function (input) {
      if (input.type === "hidden" || input.type === "checkbox") return;
      clearError(input);
      var value = (input.value || "").trim();

      if (input.hasAttribute("required") && !value) {
        showError(input, COPY.required);
        firstBad = firstBad || input;
        return;
      }
      if (!value) return;

      if (input.hasAttribute("data-rdl-work-email")) {
        if (!isEmail(value)) {
          showError(input, COPY.invalidEmail);
          firstBad = firstBad || input;
          return;
        }
        if (!isWorkEmail(value)) {
          showError(input, COPY.consumerEmail);
          firstBad = firstBad || input;
        }
      }
    });

    /* QUELL-651: the phone stays optional on this form, but a typed number
       needs its country code and at least 6 digits (shared check). */
    var QP = window.QuellPhone;
    var phone = QP ? QP.check(form, { required: false }) : null;
    if (phone) {
      showError(phone.field, phone.message);
      firstBad = firstBad || phone.field;
    }

    if (firstBad) {
      try {
        firstBad.focus({ preventScroll: false });
      } catch (e) {
        firstBad.focus();
      }
      return false;
    }
    return true;
  }

  ready(function () {
    var gate = document.querySelector("[data-rdl]");
    var form = gate && gate.querySelector("[data-rdl-form]");
    if (!gate || !form) return;

    var loginForm = gate.querySelector("[data-rdl-login]");
    var loginMessage = gate.querySelector("[data-rdl-login-message]");
    var loginSubmit = gate.querySelector("[data-rdl-login-submit]");
    var loginLabel = gate.querySelector("[data-rdl-login-label]");
    var loginText = loginLabel ? loginLabel.textContent : "";
    var views = {};
    [].slice.call(gate.querySelectorAll("[data-rdl-view]")).forEach(function (view) {
      views[view.getAttribute("data-rdl-view")] = view;
    });
    var startView = gate.getAttribute("data-rdl-start") === "signup" ? "signup" : "login";
    var fileRows = [].slice.call(gate.querySelectorAll("[data-rdl-file]"));
    var fileNames = [].slice.call(gate.querySelectorAll("[data-rdl-file-name]"));
    var submit = gate.querySelector("[data-rdl-submit]");
    var submitLabel = gate.querySelector("[data-rdl-submit-label]");
    var submitText = submitLabel ? submitLabel.textContent : "";
    var resourceNameField = gate.querySelector("[data-rdl-field-resource-name]");
    var resourceUrlField = gate.querySelector("[data-rdl-field-resource-url]");
    var pending = null;
    var lastFocus = null;
    var sending = false;

    function resetLoginMessage() {
      if (!loginMessage) return;
      loginMessage.textContent = "";
      loginMessage.hidden = true;
    }

    function show(name) {
      Object.keys(views).forEach(function (key) {
        if (key === name) views[key].removeAttribute("hidden");
        else views[key].setAttribute("hidden", "");
      });
      var first = views[name] && views[name].querySelector("input:not([type=hidden])");
      if (first) {
        try {
          first.focus({ preventScroll: true });
        } catch (e) {
          first.focus();
        }
      }
    }

    function open(context) {
      pending = context;
      busy(false);
      loginBusy(false);
      fileNames.forEach(function (el) {
        el.textContent = context.name || "";
      });
      fileRows.forEach(function (row) {
        if (context.name) row.removeAttribute("hidden");
        else row.setAttribute("hidden", "");
      });
      if (resourceNameField) resourceNameField.value = context.name || "";
      if (resourceUrlField) resourceUrlField.value = context.url || "";
      var signupAlternative = gate.querySelector("[data-rdl-signup-alternative]");
      if (signupAlternative) signupAlternative.hidden = context.dealerOnly === true;
      resetLoginMessage();

      lastFocus = document.activeElement;
      gate.removeAttribute("hidden");
      document.body.style.overflow = "hidden";
      show(context.dealerOnly ? "login" : startView);
    }

    function close() {
      pending = null;
      busy(false);
      loginBusy(false);
      gate.setAttribute("hidden", "");
      document.body.style.overflow = "";
      if (lastFocus && lastFocus.focus) {
        try {
          lastFocus.focus({ preventScroll: true });
        } catch (e) {}
      }
    }

    function busy(isBusy) {
      sending = isBusy;
      if (submit) submit.disabled = isBusy;
      if (submitLabel) submitLabel.textContent = isBusy ? COPY.preparing : submitText;
    }

    function loginBusy(isBusy) {
      sending = isBusy;
      if (loginSubmit) loginSubmit.disabled = isBusy;
      if (loginLabel) loginLabel.textContent = isBusy ? COPY.signingIn : loginText;
    }

    /* Lead consent unlocks public resources only. Protected resources resume
       the dealer script, which verifies the session and mints a fresh ticket. */
    function release(email) {
      if (pending && pending.dealerOnly) {
        var context = pending;
        loginBusy(true);
        resetLoginMessage();
        show("login");
        Promise.resolve().then(function () {
          if (typeof context.resume !== "function") throw new Error(COPY.loginFailed);
          return context.resume();
        }).then(function (started) {
          if (pending !== context) return;
          loginBusy(false);
          // A multiple-file chooser is displayed by the dealer script on the page.
          if (started === false) close();
          else if (started === true) show("done");
          else throw new Error(COPY.loginFailed);
        }).catch(function (err) {
          if (pending !== context) return;
          loginBusy(false);
          show("login");
          if (loginMessage) {
            loginMessage.textContent = err.message || COPY.loginFailed;
            loginMessage.hidden = false;
          }
        });
        return;
      }
      if (!pending || !pending.url) return;
      writeUnlock(email);
      show("done");
      download(pending.url, pending.name);
    }

    /* One delegated listener: any gated card anywhere in the section. */
    document.addEventListener("click", function (e) {
      var card = e.target.closest("[data-res-download]");
      if (!card) return;

      var url = card.getAttribute("href");
      var name = card.getAttribute("data-res-name") || "";
      if (!url) return;

      /* Let modified clicks and middle-clicks behave natively. */
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;

      e.preventDefault();

      /* An approved dealer already qualified; so did anyone who has been through the gate. */
      if (isSignedInDealer() || readUnlock()) {
        download(url, name);
        return;
      }
      open({ url: url, name: name });
    });

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      if (sending) return;
      if (pending && pending.dealerOnly) {
        show("login");
        return;
      }
      if (!validate(form)) return;

      var emailInput = form.querySelector("[data-rdl-work-email]");
      var email = emailInput ? emailInput.value.trim() : "";
      var context = pending || { url: "", name: "" };

      busy(true);
      sendLead(form, context).then(function () {
        if (pending !== context) return;
        busy(false);
        release(email);
      });
    });

    if (loginForm) {
      loginForm.addEventListener("submit", function (e) {
        e.preventDefault();
        if (sending) return;

        var emailInput = loginForm.querySelector('[name="email"]');
        var passwordInput = loginForm.querySelector('[name="password"]');
        var email = emailInput ? emailInput.value.trim() : "";
        var password = passwordInput ? passwordInput.value : "";

        [emailInput, passwordInput].forEach(function (input) {
          if (input) clearError(input);
        });
        resetLoginMessage();

        if (!email) {
          showError(emailInput, COPY.required);
          return;
        }
        if (!isEmail(email)) {
          showError(emailInput, COPY.invalidEmail);
          return;
        }
        if (!password) {
          showError(passwordInput, COPY.required);
          return;
        }

        var context = pending;
        loginBusy(true);
        dealerLogin(email, password).then(function (res) {
          if (pending !== context) return;
          loginBusy(false);
          if (res.ok) {
            /* The API has set the session cookie; the next page load will read it. Nothing to
               reload for here — the file is what the visitor came for. */
            document.documentElement.classList.add("is-dealer");
            release(email);
            return;
          }
          if (loginMessage) {
            loginMessage.textContent = res.error || COPY.loginFailed;
            loginMessage.hidden = false;
          }
        });
      });

      loginForm.addEventListener("input", function (e) {
        var input = e.target;
        if (input && input.classList && input.classList.contains("has-error")) clearError(input);
      });
    }

    form.addEventListener("input", function (e) {
      var input = e.target;
      if (input && input.classList && input.classList.contains("has-error")) clearError(input);
    });

    gate.addEventListener("click", function (e) {
      var go = e.target.closest("[data-rdl-go]");
      if (go) {
        show(pending && pending.dealerOnly ? "login" : go.getAttribute("data-rdl-go"));
        return;
      }
      if (e.target.closest("[data-rdl-close]")) {
        close();
        return;
      }
      if (e.target.closest("[data-rdl-retry]") && pending && !sending) {
        if (pending.dealerOnly) release();
        else if (pending.url) download(pending.url, pending.name);
      }
    });

    /* Other scripts (the dealer catalogue cards) open the gate through this
       event, so the first panel, the file-name rows and focus come from
       open(). Un-hiding the wrapper from outside left every panel hidden. */
    gate.addEventListener("rdl:open", function (e) {
      var detail = e.detail || {};
      open({
        url: detail.url || "",
        name: detail.name || "",
        dealerOnly: detail.dealerOnly === true,
        resume: detail.resume
      });
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !gate.hasAttribute("hidden")) close();
    });
  });
})();
